var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassiveDownvote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#262551"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_9827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8645 16.6982C19.0992 17.0793 19.5203 17.3333 20.0007 17.3333L22.0007 17.3333C22.737 17.3333 23.334 16.7364 23.334 16L23.334 11.3333C23.334 10.597 22.737 10 22.0007 10L20.0007 10C19.3744 10 18.8489 10.4318 18.7058 11.0139M18.8645 16.6982C18.7395 16.4951 18.6673 16.256 18.6673 16L18.6673 11.3333C18.6673 11.2232 18.6807 11.1163 18.7058 11.0139M18.8645 16.6982C18.088 16.9139 17.3232 17.7299 16.9993 18.4704L15.8152 21.1769C15.5396 21.8068 14.8407 22.1358 14.1796 21.9469C13.508 21.755 13.0874 21.0896 13.2022 20.4006L13.5379 18.3864C13.6057 17.98 13.2923 17.6101 12.8803 17.6101L10.2937 17.6101C9.45233 17.6101 8.82127 16.8403 8.98628 16.0153L9.7531 12.1812C9.90433 11.425 10.4759 10.8172 11.2282 10.6478C13.937 10.0381 15.5177 10.1671 18.7058 11.0139",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_9827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(24 24) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassiveDownvote);
export default __webpack_public_path__ + "static/media/passiveDownvote.339c50e97689e6058acfca800ea1eebf.svg";
export { ForwardRef as ReactComponent };